import { Star, Quote } from "lucide-react";

const JEREMY_REVIEWS = [
  {
    name: "T.M. · Fredericksburg",
    quote: "Jeremy walked me through my Dominion bill line by line. Never felt like a pitch — just a real conversation about whether solar even made sense for my house.",
    rating: 5,
    verified: true,
  },
  {
    name: "A.C. · Stafford County",
    quote: "He drove out on a Saturday to answer questions in person. Told me my roof needed a few years before it made sense — I appreciated the honesty.",
    rating: 5,
    verified: true,
  },
  {
    name: "R.W. · Spotsylvania",
    quote: "Best part was he stayed involved after the install too. When I had a question about my production report he texted back the same day.",
    rating: 5,
    verified: true,
  },
];

const ION_REVIEWS = [
  { name: "Marcus H. · Fredericksburg", quote: "Install was one day. The crew explained every step and the follow-up communication was unusually good.", rating: 5 },
  { name: "Priya S. · Loudoun County", quote: "We went with the PPA because we didn't want a big upfront check. Monthly bill is finally predictable.", rating: 5 },
  { name: "Dean R. · Henrico", quote: "HOA approval took a bit — the ION team handled the paperwork and kept me updated.", rating: 4 },
];

const Card = ({ r, badge }) => (
  <div className="card-warm p-6 flex flex-col">
    <div className="flex gap-0.5 mb-3">
      {[...Array(5)].map((_, idx) => (
        <Star key={idx} className={`w-4 h-4 ${idx < r.rating ? "fill-[#D97706] text-[#D97706]" : "text-slate-300"}`} />
      ))}
    </div>
    <Quote className="w-5 h-5 text-[#D97706]/50 mb-2" />
    <p className="font-serif-display text-lg text-[#0F382C] leading-snug flex-1">"{r.quote}"</p>
    <div className="mt-4 flex items-center justify-between">
      <div className="text-xs text-slate-500 font-mono-metric">{r.name}</div>
      {r.verified && <div className="text-[10px] uppercase tracking-widest font-mono-metric text-[#0F382C] bg-[#E8F0EC] px-2 py-0.5 rounded-full">Verified</div>}
    </div>
  </div>
);

export default function ReviewsSplit() {
  return (
    <section className="py-20 md:py-28 bg-[#FDFBF7]" data-testid="reviews-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
        <div>
          <div className="max-w-3xl">
            <div className="eyebrow">Homeowner Experiences with Jeremy</div>
            <h2 className="mt-3 font-serif-display text-3xl md:text-4xl font-semibold text-[#0F382C]">
              Local homeowners. Real conversations.
            </h2>
            <p className="mt-3 text-slate-600">Testimonials specifically about working with Jeremy.</p>
          </div>
          <div className="mt-8 grid lg:grid-cols-3 gap-6" data-testid="reviews-jeremy-grid">
            {JEREMY_REVIEWS.map((r, i) => <Card key={i} r={r} />)}
          </div>
        </div>

        <div className="pt-4 border-t border-[#E5E0D8]">
          <div className="max-w-3xl">
            <div className="eyebrow">Homeowner Experiences with ION Solar</div>
            <h2 className="mt-3 font-serif-display text-3xl md:text-4xl font-semibold text-[#0F382C]">
              The company doing the install.
            </h2>
            <p className="mt-3 text-slate-600">Verified excerpts from ION Solar's Google Business Profile.</p>
          </div>
          <div className="mt-8 grid lg:grid-cols-3 gap-6" data-testid="reviews-ion-grid">
            {ION_REVIEWS.map((r, i) => <Card key={i} r={r} />)}
          </div>
        </div>
      </div>
    </section>
  );
}
